import midpoint from '@turf/midpoint';
import { getLaneAnchorPoint } from 'components/Lane/util';
import { useKineticMapLiveProjection } from 'components/maps';
import { RecursivePartial } from 'types';
import { LocationInput, Maneuver } from '@kinetic-ui/data-layer';

type ManeuverPathProps = {
  maneuver: RecursivePartial<Maneuver>;
  location: RecursivePartial<LocationInput>;
  selected?: boolean;
  onClick?: (maneuver: RecursivePartial<Maneuver>) => void;
};

const ManeuverPath: React.FunctionComponent<ManeuverPathProps> = (props) => {
  const { selected, location, maneuver, onClick } = props;

  const approachLane = location?.lanes?.find((lane) => lane.id === maneuver.refApproachLane) ?? {};
  const departureLane =
    location?.lanes?.find((lane) => lane.id === maneuver.refDepartureLane) ?? {};

  // TS wants you to know that under no circumstances is number[] an acceptable alternative for [number, number]
  const { anchorCoordinates: approachPoint } = getLaneAnchorPoint(
    approachLane,
    location.geometry.coordinates
  );

  const approachXY = useKineticMapLiveProjection([...approachPoint]);

  const { anchorCoordinates: departurePoint } = getLaneAnchorPoint(
    departureLane,
    location.geometry.coordinates
  );
  const departureXY = useKineticMapLiveProjection([...departurePoint]);

  const approachControlPoint = midpoint(approachPoint, location.geometry);

  const approachControlXY = useKineticMapLiveProjection([
    ...approachControlPoint.geometry.coordinates,
  ] as [number, number]);

  const departureControlPoint = midpoint(departurePoint, location.geometry);
  const departureControlXY = useKineticMapLiveProjection([
    ...departureControlPoint.geometry.coordinates,
  ] as [number, number]);

  if (!approachXY || !approachControlXY || !departureControlXY || !departureXY) {
    return null;
  }

  const d = `M ${approachXY.x} ${approachXY.y}
C ${approachControlXY.x} ${approachControlXY.y},
${departureControlXY.x} ${departureControlXY.y},
${departureXY.x} ${departureXY.y}`;

  const color = selected ? '#28aae1' : '#f49d22';

  return (
    <path
      d={d}
      fill='transparent'
      onClick={() => {
        if (!selected) {
          onClick?.(maneuver);
        }
      }}
      stroke={color}
      strokeWidth={3}
      style={{ cursor: 'pointer' }}
    />
  );
};

export default ManeuverPath;
